import React, { KeyboardEvent } from 'react'

import { Card } from '@it-incubator/ui-kit'
import { useNavigate } from 'react-router-dom'

import style from './ExamCard.module.css'

import { Badge, CircleResult, Stack } from 'common/components'
import { useMediaQuery } from 'common/hooks/useMediaQuery'
import { getCardImage } from 'common/utils'
import { ExamCardDomain } from 'features/dashboard'

type PropsType = {
  card: ExamCardDomain
  addFilterHandler: (filter: string) => void
}

export const ExamCard = ({ card: { labels = [], ...card }, addFilterHandler }: PropsType) => {
  const badges = [card.category, ...labels]
  const navigate = useNavigate()
  const isMobile = useMediaQuery('(max-width: 430px)')

  if (card.level) badges.push(card.level)

  const cardKeydownHandler = (e: KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      navigate(`/test/${card.id}`)
    }
  }

  return (
    <li>
      <Card
        contentClassName={style.box}
        onClick={() => navigate(`/test/${card.id}`)}
        onKeyDown={cardKeydownHandler}
        tabIndex={0}
        aria-label="Перейти к тесту"
      >
        <div className={style.column}>
          <Stack className={style.badges}>
            {badges.map(badge => {
              if (badge.length === 0) {
                return
              }

              return (
                <Badge key={badge} onClick={() => addFilterHandler(badge)} className={style.badge}>
                  {badge}
                </Badge>
              )
            })}
          </Stack>

          <div>
            <p className={style.property}>
              {' '}
              {card.result ? `Оценка: ${card.result}%` : 'Не пройден'}
            </p>
            {card.attempts !== 0 && <p className={style.property}>{`Попыток: ${card.attempts}`}</p>}
          </div>
        </div>

        <div className={style.link}>
          <div className={style['link-column']}>
            <CircleResult value={card.result} size={isMobile ? 100 : 120}>
              <div className={style.image}>
                {<img src={card.image || getCardImage(card.category)} alt={card.title} />}
              </div>
            </CircleResult>

            <h3 className={style.title}>{card.title}</h3>
          </div>
        </div>
      </Card>
    </li>
  )
}
